import { render, staticRenderFns } from "./_logo.vue?vue&type=template&id=13924450"
import script from "./_logo.vue?vue&type=script&lang=js"
export * from "./_logo.vue?vue&type=script&lang=js"
import style0 from "./_logo.vue?vue&type=style&index=0&id=13924450&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports